<template>
    <VTextField
        ref="input"
        :label="label"
        :readonly="readonly"
        v-currency="options"
        :value="formattedValue"
        :error-messages="errorMessages"
        @change="onChange"
        @input="onInput"
    />
</template>

<script>
export default {
    name: "VCurrencyField",
    props: {
        value: {
            default: 0
        },
        label: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            default: '',
        },
        options: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            formattedValue: null
        };
    },
    watch: {
        value(value) {
            this.setValue(value);
        }
    },
    mounted() {
        this.setValue(this.value);
    },
    methods: {
        setValue(value) {
            this.$ci.setValue(this.$refs.input, value);
        },
        onInput(value) {
            this.$emit("input", this.$ci.getValue(this.$refs.input));
            this.formattedValue = value;
        },
        onChange(value) {
            this.$emit("change", this.$ci.getValue(this.$refs.input));
            this.formattedValue = value;
        }
    }
};
</script>
